import i18next from 'i18next';
import { Layout } from '../../../../queries/ats/layout/types';
import { AssetItemProps, AssetProps, AtsAssetProps } from '../atsAsset.interfaces';

export function isItem(props: AtsAssetProps): props is AssetItemProps {
  return 'item' in props;
}

export function isAsset(props: AtsAssetProps): props is AssetProps {
  return 'to' in props;
}

export function getSubtitle(
  item: Layout.SectionItem,
  pattern: Layout.Pattern,
  sectionType: Layout.SectionStyle['type'],
) {
  if (pattern === 'wide') {
    return getItemSubtitleForWidePattern(item);
  }

  if (pattern === 'poster') {
    return undefined;
  }
}

function getItemSubtitleForWidePattern(item: Layout.SectionItem) {
  const { title } = item;

  if (title === undefined || title === null) {
    return undefined;
  }

  if (title.type === 'series') {
    const { seasonCount, episodeCount } = title.series;
    const seasonText = i18next.t(seasonCount > 1 ? 'seasons' : 'season');
    const episodeText = i18next.t('episodes', { count: episodeCount });

    return `${seasonCount} ${seasonText} • ${episodeText}`;
  }

  if (title.type === 'episode') {
    return `${title?.series?.titleName} • S${title?.season?.sequenceNumber} E${title?.episode?.sequenceNumber}`;
  }

  return title.genres.slice(0, 2).join(', ');
}

export function isNonSubtitlePattern(pattern: Layout.Pattern) {
  return pattern === 'poster' || pattern === 'wide-notext-large' || pattern === 'poster-notext';
}

export function getAtsAssetTitle(item: Layout.SectionItem) {
  const { title } = item;

  if (item.name.length > 0) {
    return item.name;
  }

  if (title?.series?.titleName) {
    return title.series.titleName;
  }

  if (title?.type === 'episode') {
    return `${item.title?.episode?.sequenceNumber}. ${title.titleName}`;
  }

  return title?.titleName;
}
